import HomeAboutSec from "../../Home/HomeAboutSec";

import AboutSec2 from "../../About/AboutSec2/AboutSec2";
import HomeCtaBanner from "../../Home/HomeCtaBanner/HomeCtaBanner";
import IndustriesSec3 from "../../Industries/IndustriesSec3/IndustriesSec3";
import IndustriesSec2 from "../../Industries/IndustiresSec2/IndustriesSec2";
import SEO from "../../../components/SEO";

export default function Telecommunication({ currentLanguage = "en" }) {
  // SEO titles based on language
  const pageTitles = {
    en: "Telecommunications",
    fr: "Télécommunications", // ✅ correct French
  };

  const pageTitle = pageTitles[currentLanguage] || pageTitles.en;

  return (
    <>
      <SEO title={pageTitle} />
      <HomeAboutSec currentLanguage={currentLanguage} />
      <IndustriesSec3 currentLanguage={currentLanguage} />
      <AboutSec2 currentLanguage={currentLanguage} />
      <IndustriesSec2 currentLanguage={currentLanguage} />
      <HomeCtaBanner currentLanguage={currentLanguage} />
    </>
  );
}
